export enum ClientEditTabEnum {
    generalInfo = 0,
    contacts = 1,
    projects = 2,
    credentials = 3,
    notes = 4
}
